import React, { Component } from "react";
import { connect } from "react-redux";

import ImmutablePropTypes from "react-immutable-proptypes";
import GameListItem from "./GameListItem";

import { toggleFavouriteGame } from "./../actions/actions";

class GameList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loadedCount: 20, // Initial load
      pageSize: 20,
    };

    this.toggleFavouriteGame = this.toggleFavouriteGame.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.games !== this.props.games) {
      this.setState({ loadedCount: this.state.pageSize });
    }
  }

  loadMore() {
    const { games } = this.props;
    const { loadedCount, pageSize } = this.state;
    if (loadedCount < games.size) {
      this.setState({ loadedCount: loadedCount + pageSize });
    }
  }

  toggleFavouriteGame(game) {
    this.props.toggleFavouriteGame(game);
  }

  render() {
    const { games } = this.props;
    const { loadedCount } = this.state;
    const visibleGames = games.slice(0, loadedCount);
    const hasMore = loadedCount < games.size;

    return (
      <div className="col-md-12">
        <ul className="list-group" style={{ paddingRight: 0 }}>
          {visibleGames.map((game, i) => (
            <GameListItem
              game={game}
              key={game.get("id") || i}
              config={this.props.config}
              urlLaunchOptions={this.props.urlLaunchOptions}
              launchOptions={this.props.launchOptions}
              toggleFavourite={this.toggleFavouriteGame}
            />
          ))}
        </ul>

        {hasMore && (
          <button
            className="btn btn-primary btn-block"
            onClick={this.loadMore}
            style={{ marginTop: "10px" }}
          >
            Load More
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    toggleFavouriteGame: (game) => dispatch(toggleFavouriteGame(game)),
  };
};

GameList.propTypes = {
  config: ImmutablePropTypes.map,
  games: ImmutablePropTypes.list,
  launchOptions: ImmutablePropTypes.map,
  urlLaunchOptions: ImmutablePropTypes.map,
};

export default connect(mapStateToProps, mapDispatchToProps)(GameList);



// WEBPACK FOOTER //
// ./src/components/GameList.js